import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { BildungsangebotTerminDetail } from '../../../../../model';
import { Veranstaltungsablauf } from '../../../../../model/veranstaltungsablauf';
import { SanitizerService } from '../../../../../services/sanitizer.service';
import { DauerAnzeigeComponent } from '../../../../dauer-anzeige/dauer-anzeige.component';
import { ModalPopupComponent } from '../../../../modal/modal-popup/modal-popup.component';
import { ChipComponent } from '../../../../chip/chip.component';
import { ScreenSizeService, ViewMode } from '../../../../../services/screen-size';

@Component({
  selector: 'now-wbsuche-lib-dauer-termine',
  templateUrl: './dauer-termine.component.html',
  styleUrls: ['../keywords.scss', './dauer-termin.component.scss'],
  imports: [DauerAnzeigeComponent, DatePipe, ModalPopupComponent, AsyncPipe, ChipComponent, NgClass]
})
export class DauerTermineComponent {
  private readonly sanitizerService = inject(SanitizerService);
  private readonly screenSizeService = inject(ScreenSizeService);

  public isPhablet$ = this.screenSizeService.rangeTo$(ViewMode.PHABLET);

  @Input()
  public termin!: BildungsangebotTerminDetail;

  sanitizeFunction(html?: string): string {
    return this.sanitizerService.sanitize(html);
  }

  sortVeranstaltungsablauf(veranstaltungsablaeufe: Veranstaltungsablauf[]): Veranstaltungsablauf[] {
    return veranstaltungsablaeufe.sort((ablaufA, ablaufB) =>
      Date.parse(ablaufA?.beginn ?? '') < Date.parse(ablaufB?.beginn ?? '') ? -1 : 1
    );
  }
}
